<template>
    <div>
        <!-- <div class="no-display">
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Salary Calculation</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense class="no-display">
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Salary Month</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month"
                            :items="sal_month_list" item-text="name" item-value="id" label="Salary Month" outlined
                            @change="
              fetchSalaryRegister();
              loader = false;
            " />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Employee Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type"
                            :items="employee_type_list" item-text="name" item-value="id" label="Employee Type"
                            outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Designation</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="designation"
                            :items="designation_list" item-text="name" item-value="id" label="Designation" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Section</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="section" :items="section_list"
                            item-text="name" item-value="id" label="Section" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Employee</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
                            item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                </v-row>
                <v-row justify="space-between" class="no-display">
                    <v-col cols="12" sm="3" md="3">
                        <v-btn class="button" v-if="sal_month" @click="
              fetchSalaryRegister();
              loader = true;
            ">
                            Fetch Complete Salary Register
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn class="button" @click="dialog_register = true">An Employee Salary Register</v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="button" @click="dialog_attendance = true">Add Attendance</v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn v-if="sal_month" class="button" @click="dialog_setting = true">Salary Setting</v-btn>
                    </v-col>
                </v-row>
                <v-row justify="center" dense v-if="show_copy_dialog && loader">
                    <v-col cols="12" sm="12" md="12">
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Copy From Previous Salary Month Register</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-1 mt-1 no-display">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month_copy"
                            :items="sal_month_list" item-text="name" item-value="id" label="Salary Month" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-1 mt-1 no-display">
                        <v-autocomplete color="#0F2027" multiple dense rounded required v-model="inst_reg_copy"
                            :items="inst_list" item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                    <v-col cols="12" sm="4" class="pt-0 mt-0">
                        <v-btn class="button" v-if="sal_month_copy && inst_reg_copy != ''" @click="copySalaryRegister()"
                            :loading="copy_reg">Copy From Previous Salary Month Register</v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="no-display">
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Copy From Salary Master To Register</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-1 mt-1 no-display">
                        <v-autocomplete color="#0F2027" multiple dense rounded required v-model="inst_copy_esm"
                            :items="inst_list" item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="pt-none mt-none no-display">
                        <v-btn rounded class="button" :loading="copy_esm" @click="copySalaryMasterToRegister">Copy From
                            Salary Master To Register</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="box" v-if="emp_salary_reg_detail != '' && loader">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Employee Salary Register Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row dense>
                    <!-- export btn code -->
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" rounded color="success" outlined
                            @click="fnExcelReport('my-table-id', 'MonthlySalaryCalculation')"><v-icon
                                color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>

                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon
                                left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                    </v-col>
                </v-row>
                <!-- <v-col cols="12" sm="12" md="12"> -->
                <div id="my-table-id">
                    <v-simple-table fixed-header dense class="elevation-1 mytable" height="500px" :items-per-page="-1"
                        v-if="emp_salary_reg_detail.length > 0">
                        <thead class="toolbar">
                            <tr>
                                <td align="center">Edit</td>
                                <td align="center">Sr. No.</td>
                                <td align="center">Is Salary Blocked</td>
                                <td align="center">Is Payslip Blocked?</td>
                                <td align="center">Remark</td>
                                <td align="center">Employee</td>
                                <td align="center">No. Of Working Days</td>
                                <td align="center" v-for="(header, index) in comp_header" :key="index">
                                    {{ header }}
                                </td>
                                <td align="center">Gross Salary</td>
                                <td align="center">Gross Deduction</td>
                                <td align="center">Net Salary</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(s, index) in emp_salary_reg_detail" :key="index">
                                <td align="">
                                    <!-- {{s.edit_flag}}
                                  {{s.fmsg}} -->
                                    <v-avatar v-if="s.edit_flag == 'YES'" style="" size="25" class="edit-avatar"
                                        @click="editItem(s.sal_reg_id)">
                                        <v-icon x-small class="edit-v-icon mr-2">edit</v-icon>
                                    </v-avatar>
                                    <v-avatar v-if="s.edit_flag == 'NO'" style="" size="25" class="edit-avatar">
                                        <v-tooltip top color="black">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon x-small v-bind="attrs" v-on="on"
                                                    class="edit-v-icon mr-2">edit</v-icon>
                                            </template>
                                            <span>
                                                {{ s.fmsg }}
                                            </span>
                                        </v-tooltip>
                                    </v-avatar>
                                </td>
                                <td align="">{{ index + 1 }}</td>
                                <td align="">
                                    <v-switch class="d-flex justify-center" color="red" inset v-model="s.is_salary_blocked" @change="
                    change_salary_slip_block_status(
                      s.is_salary_blocked,
                      s.is_payslip_blocked,
                      s.sal_reg_id
                    )
                  "></v-switch>
                                </td>
                                <td align="">
                                    <v-switch class="d-flex justify-center" color="red" inset v-model="s.is_payslip_blocked" @change="
                    change_salary_slip_block_status(
                      s.is_salary_blocked,
                      s.is_payslip_blocked,
                      s.sal_reg_id
                    )
                  "></v-switch>
                                </td>
                                <td>
                                    <center>
                                        <v-tooltip top color="black">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon @click="add_update_remark( s.sal_reg_id,s.remark)" size="20"
                                                    v-bind="attrs" v-on="on" color="black">mdi-plus-circle</v-icon>
                                            </template>
                                            <span> Add Remark</span>
                                        </v-tooltip>
                                    </center>
                                </td>
                                <td align="">{{ s.emp_name }}</td>
                                <td>
                                    <center>{{ s.emp_working_days }}</center>
                                </td>
                                <!-- <td v-for="(comp,index1) in s.comp_value" :key="index1">
                                <center> 
                                   {{comp.s_value}}
                                </center> 
                              </td> -->
                                <td v-for="comp in s.comp_value" :key="comp.emp_sd_id">
                                    <center>
                                        {{ comp.s_value }}
                                        <br />
                                        <v-row dense justify="center" v-if="comp.is_rule_applicable == true">
                                            <!-- <span v-if="comp.is_rule_applicable == true && comp.rule_value">
                                                  <v-tooltip top color="black">
                                                      <template v-slot:activator="{ on, attrs }">
                                                          <v-icon size="20" v-bind="attrs" v-on="on" color="black">mdi-information</v-icon>
                                                      </template>
                                                      <span>
                                                      {{comp.rule_value}}
                                                      </span>
                                                  </v-tooltip>
                                                  <v-tooltip top color="black">
                                                      <template v-slot:activator="{ on, attrs }">
                                                          <v-icon size="20" v-bind="attrs" v-on="on" color="red" @click="removeRule(comp.emp_sd_id)">mdi-filter-remove</v-icon>
                                                      </template>
                                                      <span>
                                                      Remove Applied Rule
                                                      </span>
                                                  </v-tooltip>
                                          </span>
                                          <span v-if="comp.is_rule_applicable == true">
                                                  <v-avatar style="" size="20" class="edit-avatar" @click="addRule(comp.s_id,comp.emp_sd_id)">
                                                      <v-icon x-small class="edit-v-icon mr-2">edit</v-icon>
                                                  </v-avatar>
                                              </span> -->
                                            <span v-if="
                        comp.is_rule_applicable == true && comp.rule_value
                      ">
                                                <v-tooltip top color="black">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon size="20" v-bind="attrs" v-on="on"
                                                            color="black">mdi-information</v-icon>
                                                    </template>
                                                    <span>
                                                        {{ comp.rule_value }}
                                                    </span>
                                                </v-tooltip>
                                                <span v-if="s.edit_flag == 'YES'">
                                                    <v-tooltip top color="black">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon size="20" v-bind="attrs" v-on="on" color="red"
                                                                @click="removeRule(comp.emp_sd_id)">mdi-filter-remove</v-icon>
                                                        </template>
                                                        <span> Remove Applied Rule </span>
                                                    </v-tooltip>
                                                </span>
                                            </span>
                                            <span v-if="comp.is_rule_applicable == true">
                                                <v-avatar v-if="s.edit_flag == 'YES'" style="" size="20"
                                                    class="edit-avatar" @click="addRule(comp.s_id, comp.emp_sd_id)">
                                                    <v-icon x-small class="edit-v-icon mr-2">edit</v-icon>
                                                </v-avatar>
                                            </span>
                                        </v-row>
                                    </center>
                                </td>
                                <td>
                                    <center>{{ s.gross_salary }}</center>
                                </td>
                                <td>
                                    <center>{{ s.gross_deductions }}</center>
                                </td>
                                <td>
                                    <center>{{ s.net_salary }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <!-- </v-col> -->
            </v-card>
            <v-dialog v-model="dialog_edit" fullscreen>
                <v-card>
                    <v-row justify="center" dense>
                        <v-btn class="button mt-3" small @click="
              dialog_edit = false;
              emp_sal_reg_id = null;
            ">
                            Cancel
                        </v-btn>
                    </v-row>
                    <v-col cols="12" sm="12" md="12" v-if="dialog_edit">
                        <edit-employee-salary-register :emp_sal_reg_id="emp_sal_reg_id" :edit_flag="edit_flag"
                            @changedialog="chnaged($event)"></edit-employee-salary-register>
                    </v-col>
                    <v-row justify="center" dense>
                        <v-btn class="button mt-3" small @click="
              dialog_edit = false;
              emp_sal_reg_id = null;
            ">
                            Cancel
                        </v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_register" fullscreen>
                <v-card>
                    <v-row justify="center" dense>
                        <v-btn class="button" small @click="dialog_register = false">Cancel</v-btn>
                    </v-row>
                    <v-col cols="12" sm="12" md="12" v-if="dialog_register">
                        <employee-salary-register></employee-salary-register>
                    </v-col>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_attendance" fullscreen>
                <v-card>
                    <v-row justify="center" dense>
                        <v-btn class="button" small @click="dialog_attendance = false">Cancel</v-btn>
                    </v-row>
                    <v-col cols="12" sm="12" md="12" v-if="dialog_attendance">
                        <employee-monthly-attendace></employee-monthly-attendace>
                    </v-col>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_edit_rule" persistent max-width="1200px">
                <v-card>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong> Add Rule </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <center>
                        <v-col cols="12" sm="6" md="6">
                            <v-autocomplete dense rounded outlined v-model="comp_rule_edit" :items="component_rule_edit"
                                color="#0F2027" item-text="name" return-object label="Rule"
                                single-line></v-autocomplete>
                        </v-col>
                    </center>
                    <v-row justify="center">
                        <v-btn rounded class="button" @click="addrule_edit(comp_rule_edit)">Save</v-btn>
                        <v-btn rounded class="button" @click="dialog_edit_rule = false">Close</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_setting" fullscreen>
                <v-card>
                    <v-row justify="center" dense>
                        
                    </v-row>
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Employee Salary Settings</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-btn class="button" small @click="dialog_setting = false">Cancel</v-btn>
                    </v-toolbar>
                    <!-- <v-col cols="12" sm="12" md="12"> -->
                        <v-row dense justify="center">
                            <v-col cols="12" sm="5" md="5" style="text-align: right;">
                                <v-btn class="mt-2 mr-5" :class="release_salary ? 'btn-active' : 'btn-default'" @click="
                  release_salary = true;
                  block_salary = false;
                ">
                                    Release Employee Salary
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="5" md="5" style="text-align: left;">
                                <v-btn class="mt-2" :class="block_salary ? 'btn-active' : 'btn-default'" @click="
                  block_salary = true;
                  release_salary = false;
                ">
                                    Permanent Employee Salary Setting
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-card class="box mx-5" v-if="release_salary">
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Release Employee Salary</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-row justify="center" class="mt-4">
                                <v-col cols="12" sm="3" md="3">
                                    <v-autocomplete color="#0F2027" multiple dense rounded required
                                        v-model="inst_block_reg" :items="inst_list" item-text="name" item-value="id"
                                        label="Employee" outlined />
                                </v-col>
                                <v-col cols="12" sm="3" md="3" v-if="inst_block_reg != ''">
                                    <v-autocomplete rounded outlined dense v-model="is_salary_block_reg" :items="show_list" item-text="name"
                                        item-value="id" label="Block Salary Processing ?"></v-autocomplete>
                                </v-col>
                                 <v-col cols="12" sm="3" md="3" v-if="inst_block_reg != ''">
                                    <v-autocomplete rounded outlined dense v-model="is_salary_slip_block_reg" :items="show_list" item-text="name"
                                        item-value="id" label="Block Salary Slip ?"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="1" md="1" v-if="inst_block_reg != ''">
                                    <v-btn rounded class="button mt-0" 
                                        @click="save_block_salary_slip_reg()">Save</v-btn>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-btn class="button" @click="releaseSalaryAllEmp()" :loading="releaseSalaryAllEmp_loader">Release Salary</v-btn>
                                <v-btn class="button" @click="blockSalaryAllEmp()" :loading="blockSalaryAllEmp_loader">Block Salary</v-btn>
                                <v-btn class="button" @click="releaseSalarySlipAllEmp()" :loading="releaseSalarySlipAllEmp_loader">Release Slip</v-btn>
                                <v-btn class="button" @click="blockSalarySlipAllEmp()" :loading="blockSalarySlipAllEmp_loader">Block Slip</v-btn>
                            </v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-simple-table fixed-header dense class="elevation-1 mx-5" height="500px"
                                    v-if="emp_salary_reg_detail.length > 0">
                                    <thead>
                                        <tr class="toolbar">
                                            <td class="pa-2" align="center">Sr. No.</td>
                                            <td align="center">Salary Block Status</td>
                                            <td align="center">Payslip Block Status</td>
                                            <td align="center">Employee</td>
                                            <td align="center">Salary Month</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(s, index) in emp_salary_reg_detail" :key="index">
                                            <td align="center">{{ index + 1 }}</td>
                                            <td>
                                                <v-switch class="d-flex justify-center" color="red" inset v-model="s.is_salary_blocked" @change="
                          change_salary_slip_block_status(
                            s.is_salary_blocked,
                            s.is_payslip_blocked,
                            s.sal_reg_id
                          )
                        "></v-switch>
                                            </td>
                                            <td align="center">
                                                <v-switch class="d-flex justify-center" color="red" inset v-model="s.is_payslip_blocked" @change="
                          change_salary_slip_block_status(
                            s.is_salary_blocked,
                            s.is_payslip_blocked,
                            s.sal_reg_id
                          )
                        "></v-switch>
                                            </td>
                                            <td align="center">{{ s.emp_name }}</td>
                                            <td align="center">{{ s.sal_month }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-card>
                        <!-- .......................................release block end................................ -->
                        <v-card class="box mx-5" v-if="block_salary">
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Permanent Employee Salary Setting</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-row justify="center" class="mt-4">
                                <v-col cols="12" sm="3" md="3">
                                    <v-autocomplete color="#0F2027" multiple dense rounded required v-model="inst_block"
                                        :items="inst_list" item-text="name" item-value="id" label="Employee" outlined />
                                </v-col>
                                <v-col cols="12" sm="3" md="3" v-if="inst_block != ''">
                                    <v-autocomplete rounded outlined dense v-model="is_salary_block" :items="show_list" item-text="name"
                                        item-value="id" label="Block Salary Processing ?"></v-autocomplete>
                                </v-col>
                                 <v-col cols="12" sm="3" md="3" v-if="inst_block != ''">
                                    <v-autocomplete rounded outlined dense v-model="is_salary_slip_block" :items="show_list" item-text="name"
                                        item-value="id" label="Block Salary Slip ?"></v-autocomplete>
                                </v-col>
                                 <v-col cols="12" sm="3" md="3" v-if="inst_block != ''">
                                    <v-autocomplete rounded outlined dense v-model="sync_salary_register" :items="show_list" item-text="name"
                                        item-value="id" label="Sync Salary Register ?"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="1" md="1" class="pt-0" v-if="inst_block != ''">
                                    <v-btn rounded class="button mt-0"
                                        @click="save_perm_block_salary()">Save</v-btn>
                                </v-col>
                            </v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-simple-table fixed-header dense class="elevation-1 mx-8" height="500px"
                                    v-if="inst_data.length > 0">
                                    <thead>
                                        <tr class="toolbar">
                                            <td class="py-2"align="center">Sr. No.</td>
                                            <td align="center">Is permanent Salary Blocked ?</td>
                                            <td align="center">Is permanent Payslip Blocked ?</td>
                                            <td align="center">Employee</td>
                                            <td align="center">Employee Type</td>
                                            <td align="center">Mail Id</td>
                                            <td align="center">Sync Salary Register</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(s, index) in inst_data" :key="index">
                                            <td align="center">{{ index + 1 }}</td>
                                            <td align="center">
                                                <v-switch class="d-flex justify-center" color="red" inset v-model="s.is_parmanant_salary_blocked"
                                                    @change="
                          change_parmanant_salary_slip_block_status(
                            s.is_parmanant_salary_blocked,
                            s.is_parmanant_salary_slip_blocked,
                            s.sync_salary_register,
                            s.emp_id
                          )
                        "></v-switch>
                                            </td>
                                            <td align="center">
                                                <v-switch class="d-flex justify-center" color="red" inset v-model="s.is_parmanant_salary_slip_blocked"
                                                    @change="
                          change_parmanant_salary_slip_block_status(
                            s.is_parmanant_salary_blocked,
                            s.is_parmanant_salary_slip_blocked,
                            s.sync_salary_register,
                            s.emp_id
                          )
                        "></v-switch>
                                            </td>
                                            <td align="center">{{ s.name }}</td>
                                            <td align="center">{{ s.employeetype }}</td>
                                            <td align="center">{{ s.official_email_id }}</td>
                                            <td align="center">
                                                <v-switch class="d-flex justify-center" color="success" v-model="s.sync_salary_register" inset @change="
                          change_parmanant_salary_slip_block_status(
                            s.is_parmanant_salary_blocked,
                            s.is_parmanant_salary_slip_blocked,
                            s.sync_salary_register,
                            s.emp_id
                          )
                        "></v-switch>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-card>
                    <!-- </v-col> -->
                </v-card>
            </v-dialog>
            <!-- <v-card class="box" v-if="show_copy_dialog"> 
               <v-row justify="center" dense>
                  <v-col cols="12" sm="2">
                      <p><b>Salary Month</b></p>
                      <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month_copy" :items="sal_month_list" item-text="name" item-value="id" label="Salary Month" outlined />
                  </v-col>
                   <v-col cols="12" sm="4">
                        <p><br></p>
                        <v-btn class="button" @click="copySalaryRegister()" :loading="loader">Copy From Previous Salary Month</v-btn>
                   </v-col>
               </v-row>
          </v-card> -->
        </v-container>
        <v-dialog v-model="dialog_remark" max-width="700px">
            <v-card>
                <v-col cols="12" md="12" sm="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>Salary Register Remark</strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card class="box">
                        <v-textarea outlined name="input-7-4" v-model="remark" label="Enter Remark"> </v-textarea>
                    </v-card>
                </v-col>
                <v-row justify="center" dense>
                    <v-btn class="button" @click="addSalaryRegisterRemark()">Save / Update Remark</v-btn>
                    <v-btn class="button" @click="dialog_remark = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
    <!-- /. root div -->
</template>
<script>
  import axios from "axios";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  import EditEmployeeSalaryRegister from "../Employee/EditEmployeeSalaryRegister";
  import EmployeeMonthlyAttendance from "../Employee/EmployeeMonthlyAttendance";
import EmployeeSalaryRegister from "./EmployeeSalaryRegister";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
  export default {
      components: {
          "edit-employee-salary-register": EditEmployeeSalaryRegister,
          "employee-monthly-attendace": EmployeeMonthlyAttendance,
          "employee-salary-register": EmployeeSalaryRegister,
          Breadcrumbs
      },
      data: () => ({
          dialog_remark:false,
          loader: false,
          snackbar_msg: "",
          color: "",
          snackbar: false,
          extraBreadcrumbItems: [


          ],
          breadcrumbClass: "breadcrumb-style1",
          title: "",
          description: "",
          sal_month_list: [],
          employee_type_list: [],
          employee_list: [],
          designation_list: [],
          sal_month: null,
          sal_month_copy: null,
          inst_list: null,
          inst_block_reg: [],
          is_salary_block: null,
          is_salary_block_reg: null,
          is_salary_slip_block: null,
          is_salary_slip_block_reg: null,
          sync_salary_register: null,
          inst_reg_copy: [],
          inst_copy_esm: [],
          inst_block: [],
          employee_type: null,
          employee: null,
          designation: null,
          comp_header: [],
          emp_salary_reg_detail: [],
          show_copy_dialog: false,
          emp_sal_reg_id: null,
          dialog_edit_rule: false,
          dialog_edit: false,
          dialog_register: false,
          dialog_attendance: false,
          dialog_setting: false,
          comp_rule_edit: null,
          component_rule_edit: null,
          edit_flag: null,
          copy_reg: false,
          copy_esm: false,
          release_salary: true,
          block_salary: false,
          inst_data: [],
          overlay: false,
          section_list: [],
          section: null,
          remark:null,
          show_list: [
            { name: "Yes", id: "0" },
            { name: "No", id: "1" },
        ],
        blockSalaryAllEmp_loader:false,
        releaseSalaryAllEmp_loader:false,
        releaseSalarySlipAllEmp_loader:false,
        blockSalarySlipAllEmp_loader:false,
      }),
      methods: {
          print() {
              this.$store.state.drawer = false;
              let that = this;
              window.onafterprint = function () {
                  that.$store.state.drawer = true;
              };
              setTimeout(function () {
                  window.print();
              }, 100);
          },
          fnExcelReport(id, name) {
              var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
              tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
              tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
              tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
              tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
              tab_text = tab_text + "<table border='1px'>";
              var exportTable = $("#" + id).clone();
              exportTable.find("input").each(function (index, elem) {
                  $(elem).remove();
              });

              tab_text = tab_text + exportTable.html();
              tab_text = tab_text + "</table></body></html>";
              var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

              //Save the file
              // var blob = new Blob([tab_text], {
              //   type: "application/vnd.ms-excel;charset=utf-8",
              // });
              // window.saveAs(blob, fileName);
              const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
              const filename = name + ".xls";

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  // For IE
                  window.navigator.msSaveOrOpenBlob(blob, filename);
              } else {
                  // For modern browsers
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = filename;
                  a.click();
                  window.URL.revokeObjectURL(url);
              }
          },
          addSalaryRegisterRemark(){
            const data = {
              eid: this.emp_sal_reg_id,
              remark: this.remark
            }
            axios
                  .post("/Payroll/addSalaryRegisterRemark", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Remark Added Successfully...");
                          this.fetchSalaryRegister();
                          this.dialog_remark = false;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.dialog_remark = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.dialog_remark = false;
                  })
                  .finally(() => {
                      this.remark = null
                      this.emp_sal_reg_id = null
                  });
          },
          add_update_remark(sal_reg_id,remark){
              this.remark = remark
              this.emp_sal_reg_id = sal_reg_id
              this.dialog_remark = true
          },
          editItem(emp_sal_reg_id) {
              //  alert(emp_sal_reg_id)
              this.emp_sal_reg_id = emp_sal_reg_id;
              this.edit_flag = "yes";
              this.dialog_edit = true;
          },
          chnaged(dialog) {
              this.dialog_edit = dialog;
              this.fetchSalaryRegister();
          },
          releaseSalaryAllEmp() {
              const data = {
                  sal_month: this.sal_month,
              };
              this.releaseSalaryAllEmp_loader = true;
              axios
                  .post("/Payroll/releaseSalaryAllEmp", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Salary Released Successfully !!!");
                          this.fetchSalaryRegister();
                          this.releaseSalaryAllEmp_loader = false;
                      } else if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                          this.releaseSalaryAllEmp_loader = false;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.releaseSalaryAllEmp_loader = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.releaseSalaryAllEmp_loader = false;
                  })
                  .finally(() => {
                    this.releaseSalaryAllEmp_loader = false;
                  });
          },
          releaseSalarySlipAllEmp() {
              const data = {
                  sal_month: this.sal_month,
              };
              this.releaseSalarySlipAllEmp_loader = true;
              axios
                  .post("/Payroll/releaseSalarySlipAllEmp", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Payslip Released Successfully !!!");
                          this.fetchSalaryRegister();
                          this.releaseSalarySlipAllEmp_loader = false;
                      } else if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                          this.releaseSalarySlipAllEmp_loader = false;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.releaseSalarySlipAllEmp_loader = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.releaseSalarySlipAllEmp_loader = false;
                  })
                  .finally(() => {
                    this.releaseSalarySlipAllEmp_loader = false;
                  });
          },
          blockSalaryAllEmp() {
              const data = {
                  sal_month: this.sal_month,
              };
              this.blockSalaryAllEmp_loader = true;
              axios
                  .post("/Payroll/blockSalaryAllEmp", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Salary block Updated Successfully !!!");
                          this.fetchSalaryRegister();
                          this.blockSalaryAllEmp_loader = false;
                      } else if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                          this.blockSalaryAllEmp_loader = false;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.blockSalaryAllEmp_loader = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.blockSalaryAllEmp_loader = false;
                  })
                  .finally(() => {
                    this.blockSalaryAllEmp_loader = false;
                  });
          },
          blockSalarySlipAllEmp() {
              const data = {
                  sal_month: this.sal_month,
              };
              this.blockSalarySlipAllEmp_loader = true;
              axios
                  .post("/Payroll/blockSalarySlipAllEmp", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Payslip block Updated Successfully !!!");
                          this.fetchSalaryRegister();
                          this.blockSalarySlipAllEmp_loader = false;
                      } else if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                          this.blockSalarySlipAllEmp_loader = false;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.blockSalarySlipAllEmp_loader = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.blockSalarySlipAllEmp_loader = false;
                  })
                  .finally(() => {
                    this.blockSalarySlipAllEmp_loader = false;
                  });
          },
          change_parmanant_salary_slip_block_status(is_parmanant_salary_blocked, is_parmanant_salary_slip_blocked,sync_salary_register, emp_id) {
              const data = {
                  emp_id: emp_id,
                  is_salary_block: is_parmanant_salary_blocked,
                  is_salary_slip_block: is_parmanant_salary_slip_blocked,
                  sync_salary_register: sync_salary_register,
              };
              axios
                  .post("/Payroll/changeParmanantSalary_SlipBlockStatus", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Parmanant Salary / Payslip block Setting Updated Successfully !!!");
                      } else if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                  })
                  .finally(() => {});
          },
          change_salary_slip_block_status(is_salary_blocked, is_payslip_blocked, sal_reg_id) {
              const data = {
                  sal_reg_id: sal_reg_id,
                  is_salary_block: is_salary_blocked,
                  is_salary_slip_block: is_payslip_blocked,
              };
              axios
                  .post("/Payroll/changeSalary_SlipBlockStatus", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Salary / Payslip block Setting Updated Successfully !!!");
                      } else if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                  })
                  .finally(() => {});
          },
          save_block_salary_slip_reg() {
              const data = {
                  sal_month: this.sal_month,
                  employee: this.inst_block_reg,
                  is_salary_block: this.is_salary_block_reg,
                  is_salary_slip_block: this.is_salary_slip_block_reg,
              };
              axios
                  .post("/Payroll/savePermBlockSalaryReg", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Salary / Payslip block Setting Updated Successfully !!!");
                          this.fetchSalaryRegister();
                      } else if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                  })
                  .finally(() => {
                      this.inst_block_reg = [];
                      this.is_salary_block_reg = null;
                      this.is_salary_slip_block_reg = null;
                  });
          },
          save_perm_block_salary() {
              const data = {
                  sal_month: this.sal_month,
                  employee: this.inst_block,
                  is_salary_block: this.is_salary_block,
                  is_salary_slip_block: this.is_salary_slip_block,
                  sync_salary_register: this.sync_salary_register,
              };
              axios
                  .post("/Payroll/savePermBlockSalary", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Salary / Payslip block Setting Updated Successfully !!!");
                          this.onLoad();
                      } else if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                  })
                  .finally(() => {
                      this.inst_block = [];
                      this.is_salary_block = null;
                      this.is_salary_slip_block = null;
                      this.sync_salary_register = null;
                  });
          },
          copySalaryRegister() {
              if (this.sal_month_copy == this.sal_month) {
                  this.showSnackbar("#b71c1c", "Current & Previous salary month should be different");
                  return;
              }
              const data = {
                  sal_month_copy: this.sal_month_copy,
                  sal_month: this.sal_month,
                  employee: this.inst_reg_copy,
              };
              this.copy_reg = true;
              axios
                  .post("/Payroll/copySalaryRegister", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          //   this.emp_salary_reg_detail = res.data.emp_salary_reg_detail
                          //  this.comp_header = res.data.comp_header
                          this.showSnackbar("#4caf50", "Copy Salary Register Successfully...");
                          this.fetchSalaryRegister();
                          this.copy_reg = false;
                      } else if (res.data.flag == "No") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                          this.copy_reg = false;
                          return;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.copy_reg = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.copy_reg = false;
                  })
                  .finally(() => {
                      this.inst_reg_copy = [];
                      this.sal_month_copy = null;
                  });
          },
          fetchSalaryRegister() {
              (this.emp_salary_reg_detail = []), (this.comp_header = []);
              const data = {
                  sal_month: this.sal_month,
                  employee_type: this.employee_type,
                  designation: this.designation,
                  employee: this.employee,
                  section: this.section,
              };
              this.overlay = true;
              axios
                  .post("/Payroll/fetchSalaryRegister", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.emp_salary_reg_detail = res.data.emp_salary_reg_detail;
                          this.comp_header = res.data.comp_header;
                          this.overlay = false;
                          // this.sal_month=''
                      } else if (res.data.flag == "No") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                          this.overlay = false;
                          return;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.overlay = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.loader = false;
                  })
                  .finally(() => {
                      this.show_copy_dialog = true;
                  });
          },
          onLoad() {
              axios
                  .post("/Payroll/getInitialData")
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.sal_month_list = res.data.sal_month_list;
                          this.employee_type_list = res.data.employee_type_list;
                          this.employee_list = res.data.instlist;
                          this.designation_list = res.data.designation_list;
                          this.inst_list = res.data.inst_list;
                          this.inst_data = res.data.inst_data;
                          this.section_list = res.data.section_list;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {});
          },
          copySalaryMasterToRegister() {
              const data = {
                  sal_month: this.sal_month,
                  employee: this.inst_copy_esm,
              };
              this.copy_esm = true;
              axios
                  .post("/Payroll/copySalaryMasterToRegister", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Salary Copied Successfully...");
                          this.fetchSalaryRegister();
                          this.copy_esm = false;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.copy_esm = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.copy_esm = false;
                      this.inst_copy_esm = [];
                  });
          },

          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          removeRule(emp_sd_id) {
              const data = {
                  emp_sd_id: emp_sd_id,
                  comp_rule_edit: null,
              };
              axios
                  .post("/Payroll/removeSalaryRuleRegister", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Salary Rule Deleted Successfully...");
                          this.fetchSalaryRegister();
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.dialog_edit_rule = false;
                  });
          },
          addRule(sid, emp_sd_id) {
              this.emp_sd_id = emp_sd_id;
              const data = {
                  sid: sid,
              };
              axios
                  .post("/Payroll/addComponentRule", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.component_rule_edit = res.data.component_rule;
                          this.dialog_edit_rule = true;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                  });
          },
          addrule_edit(comp_rule_edit) {
              const data = {
                  emp_sd_id: this.emp_sd_id,
                  comp_rule_edit: comp_rule_edit,
              };
              axios
                  .post("/Payroll/UpdateSalaryRuleRegister", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.dialog_edit_rule = false;
                          this.showSnackbar("#4caf50", "Salary Rule Updated Successfully...");
                          this.fetchSalaryRegister();
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.dialog_edit_rule = false;
                  });
          },
      },
      mounted() {
          this.onLoad();
      },
      watch: {},
  };
</script>
<style scoped>
  /* .v-text-field{
    width: 80px;
} */
 .btn-default {
  background-color: #e0e0e0 !important;
  color: #000 !important;
}

.btn-active {
  background-color: #2ac3e5 !important; /* Vuetify primary blue */
  color: #fff !important;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0,0,0,0.25);
  transform: scale(0.99); /* compress effect */
  transition: all 0.15s ease;
}

  thead {
      font-weight: bold !important;
  }
  th {
      font-weight: bold !important;
  }
  tr,
  td,
  th {
      border: 1px solid black;
      /* text-align: center; */
      font-size: small;
  }
  tr,
  tbody {
      border-bottom: 1px solid black;
      border: 1px solid black;
      font-size: small;
  }
  td {
      font-size: small;
  }
  @media (min-width: 320px) {
      td,
      th {
          display: table-cell !important;
          font-size: small;
      }
      td + td,
      th + th {
          width: auto;
          font-size: small;
      }
  }
  v-simple-table {
      white-space: nowrap !important;
      /* text-align: center; */
      font-size: small;
  }

  .edit-avatar {
      transition: 0.3s;
      border: 1px solid #b0bec5;
  }
  .edit-avatar:hover {
      background-color: #b0bec5;
  }
  .edit-v-icon {
      padding-left: 6px;
      font-size: 15px;
  }
  .edit-v-icon:hover {
      color: white;
  }

  @media print {
      header,
      footer,
      nav,
      date {
          display: none !important;
      }

      table,
      td,
      tr {
          break-inside: avoid-page;
      }

      /* img {
  width: 100% !important;
} */
      .scroll {
          overflow-x: hidden;
      }

      body,
      tr,
      th,
      td,
      center {
          font-size: 14pt !important;
          font-weight: bold !important;
      }

      .no-display,
      .v-input__control,
      input[type="button"],
      input[type="submit"],
      input[type="reset"],
      #v-card {
          display: none !important;
      }

      v-card {
          border: none !important;
      }

      .trust-logo {
          width: 86%;
      }

      .schl-logo {
          width: 83%;
      }

      @page {
          size: A4;
          margin: 0px;
          /* padding: 0px; */
          /* size: 15.5in 15.5in; */
          size: 25in 19in;
      }

      .table-data {
          height: 100% !important;
          overflow-x: hidden;
          overflow-y: hidden !important;
      }

      .box {
          /* height: 100% !important; */
          overflow-x: hidden;
          border: none !important;
      }
  }
</style>
<!-- abcd -->
